
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H1V.5a.499.499 0 10-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M4.5 16.983h5c1.379 0 2.5-1.121 2.5-2.5v-11c0-1.379-1.121-2.5-2.5-2.5h-5a2.502 2.502 0 00-2.5 2.5v11c0 1.379 1.121 2.5 2.5 2.5zM3 3.483c0-.827.673-1.5 1.5-1.5h5c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5h-5c-.827 0-1.5-.673-1.5-1.5v-11zm12.5 18.516h5c1.379 0 2.5-1.121 2.5-2.5v-11c0-1.379-1.121-2.5-2.5-2.5h-5a2.502 2.502 0 00-2.5 2.5v11c0 1.379 1.121 2.5 2.5 2.5zM14 8.499c0-.827.673-1.5 1.5-1.5h5c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5h-5c-.827 0-1.5-.673-1.5-1.5v-11z"}}),_c('path',{attrs:{"d":"M4.125 6.186h1.75v1.75a.375.375 0 00.75 0v-1.75h1.75a.375.375 0 000-.75h-1.75v-1.75a.375.375 0 00-.75 0v1.75h-1.75a.375.375 0 000 .75zm13 7.063a2.375 2.375 0 100-4.75 2.375 2.375 0 000 4.75zm0-3.75c.758 0 1.375.617 1.375 1.375s-.617 1.375-1.375 1.375-1.375-.617-1.375-1.375.617-1.375 1.375-1.375zm-9 .523a.375.375 0 00-.75 0v1.75h-1.75a.375.375 0 000 .75h1.75v1.75a.375.375 0 00.75 0v-1.75h1.75a.375.375 0 000-.75h-1.75v-1.75zm8.38 7.118a2.373 2.373 0 104.746 0 2.373 2.373 0 00-4.746 0zm3.745 0c0 .757-.616 1.373-1.373 1.373s-1.373-.616-1.373-1.373.616-1.373 1.373-1.373 1.373.616 1.373 1.373z"}})])
          )
        }
      }
    